<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <div style="height: 60px"></div> -->
    <div style="width: 1rem; height: 60px"></div>
    <div class="title">
      <img
        class="title-logo"
        @click="gotoHome()"
        src="@/../static/img/logo.png"
      />

      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="/"> 首页</el-menu-item>

        <el-menu-item index="/aboutUs">关于我们</el-menu-item>
        <el-menu-item index="/products">产品服务</el-menu-item>
        <el-menu-item index="/partner">合伙人招募</el-menu-item>
        <el-menu-item index="/jobs">加入我们</el-menu-item>
        <el-menu-item index="/news">新闻资讯</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item>
      </el-menu>
    </div>
    <router-view />
    <div class="footer">
      <div class="info">
        <div class="qrcode" style="width: 110px; height: 110px">
          <!-- <img
            style="width: 110px; height: 110px; margin: 0 auto"
            src="@/../static/img/qrcode_1.png"
            alt="匡济医学APP下载"
          />
          <div class="qtitle">Android/Harmony</div> -->
        </div>
        <div class="qrcode2">
          <img
            style="width: 110px; height: 110px; margin: 0 auto"
            src="@/../static/img/qrcode_2.png"
            alt="匡济医学公众号"
          />
          <div class="qtitle">匡济医学公众号</div>
        </div>
        <div class="cinfo">
          <div class="">深 圳 市 匡 济 医 学 科 技 有 限 公 司</div>
          <div class="">
            <div style="display: inline">
              <img
                class="pull-left"
                style="width: 20px"
                src="@/../static/img/foot_tel.png"
              />
              <span
                class="pull-left"
                style="padding-left: 10px; padding-right: 10px"
              >
                0755-26559369</span
              >
              <img
                class="pull-left"
                style="width: 20px"
                src="@/../static/img/foot_url.png"
              />
              <span class="pull-left" style="padding-left: 10px">
                www.comtcare.com</span
              >
            </div>
          </div>
          <div class="" style="width: 100%">
            <span
              ><img
                class="pull-left"
                style="width: 20px"
                src="@/../static/img/foot_location.png"
              />
            </span>
            <span style="padding-left: 10px"
              >深圳市南山区科技园高新北六道兰光科技园A811室</span
            >
          </div>
          <div class="">
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >粤ICP备2021029136</a
            >
          </div>
        </div>
      </div>
      <div class="clear-both comp">
        深圳市匡济医学科技有限公司 Copyright © Shenzhen Kuang Ji Medical Technology Co., Ltd.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    activeIndex() {
      return this.$route.path;
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goGov() {
      window.open("https://beian.miit.gov.cn/");
    },
    gotoHome() {
      this.$router.push({ path: "/" });
    },

    handleSelect(key) {
      this.$router.push({ path: key });
      console.log(key);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* min-width: 1360px; */
}
</style>
<style lang='less' scoped>
.title {
  width: 100%;
  // height: 100%;
  height: 64px;
  display: flex;
  border-bottom: 1px solid #fff;
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 1000;
  .title-logo {
    width: 2.4rem;
    height: 0.5rem;
    margin: auto 1.3rem auto 4.7rem;
  }
  .el-menu-demo {
    width: 11rem;
  }
}
.el-menu.el-menu--horizontal {
  border: none;
}
.pull-left {
  float: left;
}
.clear-both {
  clear: both;
}
.footer {
  width: 100%;
  color: #fff;
  min-height: 300px;
  background-image: url("../static/img/footer.png");
  background-size: 100% 100%;
  -moz-background-size: 100% 100%; /* 老版本的 Firefox */
  background-repeat: no-repeat;
  position: relative;
  .info {
    padding-top: 80px;
    margin: 0 auto;
    width: 900px;
    a {
      color: #fff;
    }
    .qrcode {
      float: left;
      width: 150px;
      // display: flex;
      // justify-content: center;
      // align-content: center;
      // flex-direction: column;
      // text-align: center;
      margin-right: 50px;
    }
    .qrcode2 {
      float: left;
      width: 150px;
      text-align: center;
      margin-right: 100px;
    }
    .qtitle {
      font-size: 16px;
      padding-top: 5px;
    }
    .cinfo {
      font-size: 16px;
      line-height: 130%;
      text-align: left;
      div {
        padding-top: 2px;
        padding-bottom: 7px;
        padding-left: 7px;
      }
    }
  }
  .comp {
    width: 100%;
    padding-bottom: 5px;
    text-align: center;
    font-size: 14px;
    position: absolute;
    bottom: 0;
  }
}
.el-menu-item {
  color: #303133;
}
.el-menu-item.is-active {
  border-bottom: 2px solid #409eff;
  color: black;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/App.vue